var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLaunch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 0H2.22222C0.988889 0 0 1 0 2.22222V15.5556C0 16.7778 0.988889 17.7778 2.22222 17.7778H6.66667V15.5556H2.22222V4.44444H17.7778V15.5556H13.3333V17.7778H17.7778C19 17.7778 20 16.7778 20 15.5556V2.22222C20 1 19.0111 0 17.7778 0ZM10 6.66667L5.55556 11.1111H8.88889V17.7778H11.1111V11.1111H14.4444L10 6.66667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLaunch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_launch.8cf4c5b08323cdb05e4e469d97e5360a.svg";